import React, {Component} from 'react';
import TextField from '../../lib/mdb/text-field';

/**
 * Renders the Card Expiry Date
 *
 * Expected parameters:
 * FIXME need to update here
 */
class CardExpiryDate extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {config} = this.props,
            {messages} = config;

        return (
            <TextField
                name="paymentMethod.creditCardExpiryDate"
                placeholder={messages["opp.cardExpiry.tip"]}
                description={messages["opp.cardExpiry.label"]}
                maxLength="5"
                className="md-form form-group"
                labelClass="bootstrap-label"
                aria-required="true"
                validations={{
                    required: messages["opp.validation.cardExpiry.required"],
                    validExpiryDate: messages["opp.validation.cardExpiry.invalid"]
                }}
                cleaveOptions={{
                    date: true,
                    datePattern: ['m', 'y']
                }}
                autoComplete="off"/>
        )
    }
}

export default CardExpiryDate
